<!-- components/InfoTextCell.vue -->
<template>
  <div
    class="d-flex flex-column justify-center align-center"
    style="min-height: 55px;"
  >
    {{ primary }}
  </div>
</template>

<script>
export default {
  name: "InfoTextCell",
  props: {
    primary: {
      required: true,
    },
    secondary: {
      required: false,
      default: null,
    }, 
    secondaryrequired: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
